import React, { useEffect, useState } from 'react';
import { PaymentDetailsTabsData } from './PaymentDetailsTabsData';
import {
  GetOfferSignedInvoices,
  GetReservationInvoices,
} from '../../../../../Services';
import { PaymentInvoicesView } from './PaymentInvoicesView/PaymentInvoicesView';
import { InvoiceDetailsView } from '../PaymentDetails/InvoiceDetailsView/InvoiceDetailsView';
import { InvoiceReceiptView } from '../PaymentDetails/InvoiceReceiptView/InvoiceReceiptView';

function DepositAndFeesVerificationView({
  unitData,
  backButton,
  onSelectedChanged,
  unitTransactionId,
  parentTranslationPath,
  checkIfDepositAndFeesVerificationNextBlocked,
  setIsBackButtonHidden,
}) {
  const translationPath = 'DepositAndFeesVerificationView.';
  const [activeView, setActiveView] = useState(
    Object.values(PaymentDetailsTabsData)[0]
  );
  const [activeInvoiceId, setActiveInvoiceId] = useState(null);
  const [paymentInvoices, setPaymentInvoices] = useState([]);

  const getAllInvoices = async () => {
    const res = await GetReservationInvoices(unitTransactionId);
    if (!((res && res.data && res.data.ErrorId) || !res)) {
      if (res?.length > 0) {
        setPaymentInvoices(res);
        const invoicesIds = res.map((item) => item.invoiceId) || [];
        onSelectedChanged({ id: 'invoicesIds', value: invoicesIds });
      } else {
        setPaymentInvoices([]);
        onSelectedChanged({ id: 'invoicesIds', value: [] });
      }
    } else setPaymentInvoices([]);
  };

  const GetOfferSignedInvoicesByTransactionId = async () => {
    const res = await GetOfferSignedInvoices(unitTransactionId);
    if (!((res && res.data && res.data.ErrorId) || !res)) {
      if (res?.length > 0) {
        setPaymentInvoices(res);
        const invoicesIds = res.map((item) => item.invoiceId) || [];
        onSelectedChanged({ id: 'invoicesIds', value: invoicesIds });
      } else {
        setPaymentInvoices([]);
        onSelectedChanged({ id: 'invoicesIds', value: [] });
      }
    } else setPaymentInvoices([]);
  };

  const activeInvoiceHandler = (Id) => {
    setActiveInvoiceId(Id);
  };

  const activeViewHandler = (viewItem) => {
    setActiveView(viewItem);
  };

  const backButtonHandler = () => {
    activeViewHandler(PaymentDetailsTabsData.PaymentInvoices);
    const isClickedResetValue = false;
    backButton.clickHandler(isClickedResetValue);
  };

  const reloadInvoices = () => {
    if (
      unitTransactionId &&
      (unitData?.unitStatus?.name.toLowerCase() !== 'offersigned' ||
        unitData?.unitStatus?.value.toLowerCase() !== 'offersigned')
    ) {
      getAllInvoices();
    } else if (
      unitData?.id &&
      (unitData?.unitStatus?.name.toLowerCase() === 'offersigned' ||
        unitData?.unitStatus?.value.toLowerCase() === 'offersigned')
    ) {
      if (unitTransactionId) {
        GetOfferSignedInvoicesByTransactionId();
      }
    }
  };

  useEffect(() => {
    if (
      unitTransactionId &&
      (unitData?.unitStatus?.name.toLowerCase() !== 'offersigned' ||
        unitData?.unitStatus?.value.toLowerCase() !== 'offersigned')
    ) {
      getAllInvoices();
    } else if (
      unitData?.id &&
      (unitData?.unitStatus?.name.toLowerCase() === 'offersigned' ||
        unitData?.unitStatus?.value.toLowerCase() === 'offersigned')
    ) {
      if (unitTransactionId) {
        GetOfferSignedInvoicesByTransactionId();
      }
    }
  }, [unitTransactionId, unitData]);

  useEffect(() => {
    if (backButton.isClicked) backButtonHandler();
  }, [backButton.isClicked]);

  useEffect(() => {
    checkIfDepositAndFeesVerificationNextBlocked(paymentInvoices);
  }, [paymentInvoices]);

  useEffect(() => {
    if (activeView.key == PaymentDetailsTabsData.PaymentInvoices.key) {
      setIsBackButtonHidden(false);
    } else {
      setIsBackButtonHidden(true);
    }
  }, [activeView]);

  return (
    <div className='Payment-Details-phase'>
      {activeView.key == PaymentDetailsTabsData.PaymentInvoices.key ? (
        <PaymentInvoicesView
          activeInvoiceHandler={activeInvoiceHandler}
          unitTransactionId={unitTransactionId}
          activeViewHandler={activeViewHandler}
          parentTranslationPath={parentTranslationPath}
          translationPath={translationPath}
          paymentInvoices={paymentInvoices}
          reloadInvoices={reloadInvoices}
        />
      ) : null}
      {activeView.key == PaymentDetailsTabsData.InvoiceDetails.key ? (
        <InvoiceDetailsView
          activeInvoiceId={activeInvoiceId}
          activeViewHandler={activeViewHandler}
          parentTranslationPath={parentTranslationPath}
          translationPath={translationPath}
        />
      ) : null}

      {activeView.key == PaymentDetailsTabsData.InvoiceReceipt.key ? (
        <InvoiceReceiptView
          activeInvoiceId={activeInvoiceId}
          unitTransactionId={unitTransactionId}
          activeViewHandler={activeViewHandler}
          reloadInvoices={reloadInvoices}
          parentTranslationPath={parentTranslationPath}
          translationPath={translationPath}
        />
      ) : null}
    </div>
  );
}

export default DepositAndFeesVerificationView;
